<template>
	<div>
		<post-title
			v-if="!loadingPost && !loadingProfile"
			:post="this.getPostCurrent"
			:detail="this.getCurrentProfile"
		/>

		<a-tabs type="card" class="post-detail">
			<a-tab-pane key="1" tab="Post">
				<post-info v-if="!loadingPost" :post="this.getPostCurrent" />
			</a-tab-pane>
			<!-- <a-tab-pane key="2" tab="Hashtag">
				<post-hashtag v-if="!loadingPost" :post="this.getPostCurrent" />
			</a-tab-pane>
			<a-tab-pane key="3" tab="Comments">
				<post-comment v-if="!loadingPost" :post="this.getPostCurrent" />
			</a-tab-pane> -->
			<a-tab-pane key="4" tab="Media">
				<post-media v-if="!loadingPost" :post="this.getPostCurrent" />
			</a-tab-pane>
			<!-- <a-tab-pane key="5" tab="Content">
				COMING SOON
			</a-tab-pane> -->
			<a-tab-pane key="6" tab="Evolution">
				<PostEvolution v-if="!loadingPost" :post="this.getPostCurrent" />
			</a-tab-pane>
		</a-tabs>
	</div>
</template>

<script>
import PostTitle from '@/components/widgets/Post/Title'
import PostInfo from '@/components/widgets/Post/Info'
// import PostHashtag from '@/components/widgets/Post/Hashtag'
// import PostComment from '@/components/widgets/Post/Comment'
import PostMedia from '@/components/widgets/Post/Media'
import PostEvolution from '@/components/widgets/Post/Evolution'

import { mapGetters, mapActions } from 'vuex'
import * as ACTIONS from '../../store/actions'

export default {
	name: 'Post',
	components: {
		PostTitle,
		PostInfo,
		// PostHashtag,
		// PostComment,
		PostMedia,
		PostEvolution,
	},
	data: function() {
		return {
			loadingPost: true,
			loadingProfile: false,
		}
	},
	created() {
		this.loadingProfile = true

		this.loadPost({ id: this.$route.params.postId })
			.then(() => {
				let { detailId } = this.getPostCurrent

				this.loadProfile(detailId).then(res => {
					this.loadingProfile = false
				})

				this.loadingPost = false
			})
			.catch(e => {
				this.$notification.info('Opsss', 'El post no existe')
				this.$router.go(-1)
			})
	},
	methods: {
		...mapActions({
			loadPost: ACTIONS.POST.BY_ID,
			loadProfile: ACTIONS.DETAIL.BY_ID,
		}),
	},
	computed: {
		...mapGetters(['getPostCurrent', 'getCurrentProfile']),
	},
}
</script>

<style lang="scss">
@import './style.module.scss';
</style>
